import { combineReducers } from "redux";
import auth from './auth';
import users from './users';
import organizations from './organizations';
import projects from './projects';
import posts from './posts';
import messages from './messages';
import invitations from './invitations';
import assets from './assets';
import activities from './activities';
import campaigns from './campaigns';
import ideas from './ideas';
import actionables from './actionables';
import payment_methods from './payment_methods';
import campaign_themes from './campaign_themes';
import content_plans from './content_plans';
import subscriptions from './subscriptions';
import notifications from './notifications';
import social_profiles from './social_profiles';
import proposals from './proposals';
export default combineReducers({ 
  auth,
  users,
  projects,
  organizations,
  posts,
  messages,
  invitations,
  assets,
  activities,
  campaigns,
  actionables,
  payment_methods,
  campaign_themes,
  ideas,
  content_plans,
  subscriptions,
  notifications,
  proposals,
  social_profiles
});